/**
 * Dynamically loads a CSS file by creating a link element and appending it to the document head.
 * The function returns a Promise that resolves when the CSS is loaded or rejects if loading fails.
 *
 * @param {string} url - The URL of the CSS file to load.
 * @returns {Promise<void>} A Promise that resolves when the CSS file has been loaded successfully.
 */
export const loadStylesheet = (url) => new Promise((resolve, reject) => {
  if (document.querySelector(`link[href="${url}"]`)) {
    resolve();
    return;
  }

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = url;

  link.onload = () => resolve();
  link.onerror = () => reject(new Error(`Failed to load CSS: ${url}`));

  document.head.appendChild(link);
});

export default loadStylesheet;
